import React from "react";
import {
  ComposedChart,
  Bar,
  Cell,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
  Legend,
} from "recharts";
import { macd, monthYearLabel, fullDateLabel, monthlyTicks } from "../../lib/indicators";

const BUY = "oklch(0.58 0.13 145)";
const SELL = "oklch(0.55 0.21 25)";

export default function MacdChart({ data }) {
  const closes = data.map((d) => Number(d.close));
  const { macdLine, signalLine, histogram } = macd(closes, 12, 26, 9);

  const series = data.map((d, i) => ({
    raw_date: d.quote_date,
    macd: macdLine[i] != null ? +macdLine[i].toFixed(4) : null,
    signal: signalLine[i] != null ? +signalLine[i].toFixed(4) : null,
    hist: histogram[i] != null ? +histogram[i].toFixed(4) : null,
  }));
  const ticks = monthlyTicks(series);

  return (
    <div className="space-y-2">
      <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">
        MACD (12, 26, 9) · força do trend
      </div>
      <div className="h-[180px] w-full">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={series} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="oklch(0.92 0.004 286.32)" vertical={false} />
            <XAxis dataKey="raw_date" ticks={ticks} tickFormatter={monthYearLabel} interval={0} tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" />
            <YAxis tick={{ fontSize: 10 }} stroke="oklch(0.552 0.016 285.938)" width={45} />
            <Tooltip
              contentStyle={{ background: "var(--popover)", border: "1px solid var(--border)", fontSize: 12 }}
              labelFormatter={fullDateLabel}
              formatter={(v, n) => [Number(v).toFixed(4), n]}
            />
            <Legend wrapperStyle={{ fontSize: 11 }} />
            <ReferenceLine y={0} stroke="oklch(0.552 0.016 285.938)" />
            <Bar dataKey="hist" name="Histograma" isAnimationActive={false}>
              {series.map((s, idx) => (
                <Cell key={idx} fill={(s.hist || 0) >= 0 ? BUY : SELL} opacity={0.55} />
              ))}
            </Bar>
            <Line type="monotone" dataKey="macd" name="MACD" stroke="oklch(0.52 0.105 223.128)" strokeWidth={1.6} dot={false} isAnimationActive={false} />
            <Line type="monotone" dataKey="signal" name="Signal" stroke="oklch(0.45 0.085 224.283)" strokeWidth={1.4} strokeDasharray="3 3" dot={false} isAnimationActive={false} />
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
